/**
 * Reports service
 */

import { apiClient } from '../utils/api';
import type { Report, ApiResponse } from '../../../shared/src/types';

export interface GenerateReportData {
  checklist_run_id: string;
}

export async function generateReport(data: GenerateReportData): Promise<Report> {
  const response = await apiClient.post<ApiResponse<Report>>('/reports/generate', data);

  if (response.data.error) {
    throw new Error(response.data.error.message || 'Error generating report');
  }

  if (!response.data.data) {
    throw new Error('Invalid response from server');
  }

  return response.data.data;
}

export async function listReports(installationId?: string, checklistRunId?: string): Promise<Report[]> {
  const queryParams = new URLSearchParams();
  if (installationId) queryParams.append('installation_id', installationId);
  if (checklistRunId) queryParams.append('checklist_run_id', checklistRunId);

  const url = `/reports${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  const response = await apiClient.get<ApiResponse<Report[]>>(url);

  if (response.data.error) {
    throw new Error(response.data.error.message || 'Error fetching reports');
  }

  return response.data.data || [];
}

export async function getReport(id: string): Promise<Report> {
  const response = await apiClient.get<ApiResponse<Report>>(`/reports/${id}`);

  if (response.data.error) {
    throw new Error(response.data.error.message || 'Error fetching report');
  }

  if (!response.data.data) {
    throw new Error('Report not found');
  }

  return response.data.data;
}

export async function downloadReport(id: string): Promise<Blob> {
  const response = await apiClient.get(`/reports/${id}/download`, {
    responseType: 'blob',
  });

  return response.data;
}

